/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Challenge_Paywall_Special_OfferInputs */

const en_starter_challenge_paywall_special_offer = /** @type {(inputs: Starter_Challenge_Paywall_Special_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One-Time Offer`)
};

const ar_starter_challenge_paywall_special_offer = /** @type {(inputs: Starter_Challenge_Paywall_Special_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض لمرة واحدة فقط`)
};

const de_starter_challenge_paywall_special_offer = /** @type {(inputs: Starter_Challenge_Paywall_Special_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einmaliges Angebot`)
};

const es_starter_challenge_paywall_special_offer = /** @type {(inputs: Starter_Challenge_Paywall_Special_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta única`)
};

const fr_starter_challenge_paywall_special_offer = /** @type {(inputs: Starter_Challenge_Paywall_Special_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offre unique`)
};

const it_starter_challenge_paywall_special_offer = /** @type {(inputs: Starter_Challenge_Paywall_Special_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerta unica`)
};

const ja_starter_challenge_paywall_special_offer = /** @type {(inputs: Starter_Challenge_Paywall_Special_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一度限りのオファー`)
};

const ko_starter_challenge_paywall_special_offer = /** @type {(inputs: Starter_Challenge_Paywall_Special_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`단 한 번뿐인 혜택`)
};

const pt_br_starter_challenge_paywall_special_offer = /** @type {(inputs: Starter_Challenge_Paywall_Special_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta única`)
};

const ru_starter_challenge_paywall_special_offer = /** @type {(inputs: Starter_Challenge_Paywall_Special_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разовое предложение`)
};

const th_starter_challenge_paywall_special_offer = /** @type {(inputs: Starter_Challenge_Paywall_Special_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอเพียงครั้งเดียว`)
};

const tr_starter_challenge_paywall_special_offer = /** @type {(inputs: Starter_Challenge_Paywall_Special_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tek seferlik teklif`)
};

const zh_cn_starter_challenge_paywall_special_offer = /** @type {(inputs: Starter_Challenge_Paywall_Special_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`优惠仅此一次`)
};

const zh_tw_starter_challenge_paywall_special_offer = /** @type {(inputs: Starter_Challenge_Paywall_Special_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`優惠僅此一次`)
};

/**
* | output |
* | --- |
* | "One-Time Offer" |
*
* @param {Starter_Challenge_Paywall_Special_OfferInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_challenge_paywall_special_offer = /** @type {((inputs?: Starter_Challenge_Paywall_Special_OfferInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Challenge_Paywall_Special_OfferInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_challenge_paywall_special_offer(inputs)
	if (locale === "ar") return ar_starter_challenge_paywall_special_offer(inputs)
	if (locale === "de") return de_starter_challenge_paywall_special_offer(inputs)
	if (locale === "es") return es_starter_challenge_paywall_special_offer(inputs)
	if (locale === "fr") return fr_starter_challenge_paywall_special_offer(inputs)
	if (locale === "it") return it_starter_challenge_paywall_special_offer(inputs)
	if (locale === "ja") return ja_starter_challenge_paywall_special_offer(inputs)
	if (locale === "ko") return ko_starter_challenge_paywall_special_offer(inputs)
	if (locale === "pt_br") return pt_br_starter_challenge_paywall_special_offer(inputs)
	if (locale === "ru") return ru_starter_challenge_paywall_special_offer(inputs)
	if (locale === "th") return th_starter_challenge_paywall_special_offer(inputs)
	if (locale === "tr") return tr_starter_challenge_paywall_special_offer(inputs)
	if (locale === "zh_cn") return zh_cn_starter_challenge_paywall_special_offer(inputs)
	return zh_tw_starter_challenge_paywall_special_offer(inputs)
});